import { render, staticRenderFns } from "./WorkflowStats.vue?vue&type=template&id=79915b49&scoped=true"
import script from "./WorkflowStats.vue?vue&type=script&lang=js"
export * from "./WorkflowStats.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStats.vue?vue&type=style&index=0&id=79915b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79915b49",
  null
  
)

export default component.exports